module.exports = __webpack_public_path__ + "img/opastuspiste_original.0c890e9f.jpg";